import { getColor } from '@panel/commons/core/themev3';
import styled, { css } from 'styled-components';

const commonBtns = css`
  -webkit-appearance: none;
  outline: none;
  height: 40px;
  border-radius: 8px;
  padding: 0px 12px;
  color: #fff;
  text-shadow: 0 0 0.6px #fff, 0 0 0.6px #fff, 0 0 0.6px #fff;
  :hover {
    cursor: pointer;
  }
  :disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

const Button = styled.button`
  ${commonBtns};
  background-color: ${getColor('primary')};
  display: ${props => props.hide && 'none'};
  min-width: 110px;
  justify-self: flex-end;
  text-align: center;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  ${({ device }) =>
    device === 'mobile'
      ? css`
          height: 48px;
        `
      : ''}
  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `}
  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `}
  :hover {
    background-color: ${getColor('primaryHover')};
  }
`;

const ButtonOutline = styled(Button)`
  background-color: #fff;
  border: 1px solid ${getColor('primary')};
  color: #000;
  :hover {
    background-color: ${getColor('secondaryHover')};
  }
`;

const ButtonWithoutBackground = styled(Button)`
  background-color: transparent;
  border: none;
  color: #000;
  :hover {
    background-color: ${getColor('tertiaryHover')};
  }
`;

export { Button, ButtonOutline, ButtonWithoutBackground };
